module.exports = __webpack_public_path__ + "static/img/jz2.ee3440b.png";


//////////////////
// WEBPACK FOOTER
// ./static/jz2.png
// module id = Rac7
// module chunks = 2